export type LicenseStatus =
  | 'exam_pending'
  | 'exam_passed_waiting_3m'
  | 'interview_scheduled'
  | 'interview_passed'
  | 'interview_failed'
  | 'license_issued'
  | 'failed'

export interface License {
  id: string | null
  userId: string | null
  programmeId: string | null
  programmeType: string | null
  programmeTitle?: string | null
  type?: string | null
  examScore: number | null
  examPassed: boolean | null
  examTakenAt: string | null
  invitedToInterview: boolean | null
  interviewScheduledAt: string | null
  interviewZoomLink: string | null
  interviewScore: number | null
  interviewPassed: boolean | null
  licenseIssued: boolean | null
  licenseIssuedAt: string | null
  licenseReference: string | null
  notes: string | null
  status: LicenseStatus | null
  createdAt: string | null
  updatedAt: string | null
}

export class LicenseModel implements License {
  id: string | null
  userId: string | null
  programmeId: string | null
  programmeType: string | null
  programmeTitle?: string | null
  type?: string | null
  examScore: number | null
  examPassed: boolean | null
  examTakenAt: string | null
  invitedToInterview: boolean | null
  interviewScheduledAt: string | null
  interviewZoomLink: string | null
  interviewScore: number | null
  interviewPassed: boolean | null
  licenseIssued: boolean | null
  licenseIssuedAt: string | null
  licenseReference: string | null
  notes: string | null
  status: LicenseStatus | null
  createdAt: string | null
  updatedAt: string | null

  constructor(data?: Partial<LicenseModel>) {
    this.id = data?.id ?? null
    this.userId = data?.userId ?? null
    this.programmeId = data?.programmeId ?? null
    this.programmeType = data?.programmeType ?? null
    this.programmeTitle = data?.programmeTitle ?? null
    this.type = data?.type ?? null
    this.examScore = data?.examScore ?? null
    this.examPassed = data?.examPassed ?? null
    this.examTakenAt = data?.examTakenAt ?? null
    this.invitedToInterview = data?.invitedToInterview ?? null
    this.interviewScheduledAt = data?.interviewScheduledAt ?? null
    this.interviewZoomLink = data?.interviewZoomLink ?? null
    this.interviewScore = data?.interviewScore ?? null
    this.interviewPassed = data?.interviewPassed ?? null
    this.licenseIssued = data?.licenseIssued ?? null
    this.licenseIssuedAt = data?.licenseIssuedAt ?? null
    this.licenseReference = data?.licenseReference ?? null
    this.notes = data?.notes ?? null
    this.status = data?.status ?? null
    this.createdAt = data?.createdAt ?? null
    this.updatedAt = data?.updatedAt ?? null
  }

  static fromJSON(json: any): LicenseModel {
    if (!json) {
      return new LicenseModel()
    }

    const toNumber = (value: any): number | null => {
      if (value === null || value === undefined || value === '') return null
      const parsed = typeof value === 'number' ? value : Number(value)
      return Number.isFinite(parsed) ? parsed : null
    }

    const programme = json.programme ?? null
    let programmeTitle: string | null = null
    if (programme) {
      if (typeof programme === 'string') {
        programmeTitle = programme
      } else if (typeof programme === 'object') {
        programmeTitle = programme.title ?? programme.name ?? null
      }
    }

    return new LicenseModel({
      id: json.id ?? json.licenseId ?? null,
      userId: json.user_id ?? json.userId ?? null,
      programmeId: json.programme_id ?? json.programmeId ?? null,
      programmeType: json.programme_type ?? json.programmeType ?? null,
      programmeTitle,
      type: json.type ?? null,
      examScore: toNumber(json.exam_score ?? json.examScore),
      examPassed: json.exam_passed ?? json.examPassed ?? null,
      examTakenAt: json.exam_taken_at ?? json.examTakenAt ?? null,
      invitedToInterview: json.invited_to_interview ?? json.invitedToInterview ?? null,
      interviewScheduledAt: json.interview_scheduled_at ?? json.interviewScheduledAt ?? null,
      interviewZoomLink: json.interview_zoom_link ?? json.interviewZoomLink ?? null,
      interviewScore: toNumber(json.interview_score ?? json.interviewScore),
      interviewPassed: json.interview_passed ?? json.interviewPassed ?? null,
      licenseIssued: json.license_issued ?? json.licenseIssued ?? null,
      licenseIssuedAt: json.license_issued_at ?? json.licenseIssuedAt ?? null,
      licenseReference: json.license_reference ?? json.licenseReference ?? null,
      notes: json.notes ?? null,
      status: json.status ?? null,
      createdAt: json.created_at ?? json.createdAt ?? null,
      updatedAt: json.updated_at ?? json.updatedAt ?? null,
    })
  }
}
